import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePaginationActions from "../../../../../../globals/components/TablePaginationActions";
import { CarrierTabEmptyRow, CarrierTabLoadingRow } from "./carrierTabTablePrimitives";

export default function CarrierCompaniesTabPanel({ vm }) {
  const {
    handleOpenCompanyDialog,
    deleteCompanyLoading,
    handleDeleteCompany,
    handleEditCompanyClick,
    rowsPerPageCompanies,
    editCompanyLoading,
    handleChangePageCompanies,
    handleChangeRowsPerPageCompanies,
    handleDefaultChange,
    paginationSx,
    companiesLoading,
    companies,
    headerRowSx,
    pageCompanies,
    tableCardSx,
  } = vm;

  const renderBody = () => {
    if (companiesLoading) {
      return <CarrierTabLoadingRow colSpan={4} />;
    }
    if (companies.length === 0) {
      return <CarrierTabEmptyRow colSpan={4} message="No companies found." />;
    }
    const slice = companies.slice(
      pageCompanies * rowsPerPageCompanies,
      pageCompanies * rowsPerPageCompanies + rowsPerPageCompanies,
    );
    return slice.map((company) => (
      <TableRow key={company.carrier_company_id}>
        <TableCell>{company.carrier_company_name}</TableCell>
        <TableCell align="right">{company.carrier_company_naic}</TableCell>
        <TableCell align="right">
          <Checkbox
            checked={company.isDefault}
            onChange={() => handleDefaultChange(company.carrier_company_naic)}
          />
        </TableCell>
        <TableCell align="right">
          <IconButton
            color="primary"
            onClick={() => handleEditCompanyClick(company.carrier_company_id)}
            disabled={editCompanyLoading || deleteCompanyLoading}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => handleDeleteCompany(company.carrier_company_id)}
            disabled={editCompanyLoading || deleteCompanyLoading}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenCompanyDialog}>
          Add Company
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>Company Name</TableCell>
              <TableCell align="right">NAIC</TableCell>
              <TableCell align="right">Default</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        component="div"
        count={companies.length}
        page={pageCompanies}
        onPageChange={handleChangePageCompanies}
        rowsPerPage={rowsPerPageCompanies}
        onRowsPerPageChange={handleChangeRowsPerPageCompanies}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={paginationSx}
      />
    </>
  );
}

CarrierCompaniesTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
